import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Modal } from '../../../ps-aspect-design';
import Select from 'ps-components/ReactSelect/ReactSelect';
import { getCurrencies, setCurrency } from '../../../reducers/modules/currency/currency';
import { connect } from 'react-redux';
import { CustomDropdownIndicator } from '../CustomDropdownIndicator';

import './Select.scss';

export class CurrencySelect extends Component {
  static propTypes = {
    currencies: PropTypes.array,
    getCurrencies: PropTypes.func,
    currencyChange: PropTypes.func,
    setCurrency: PropTypes.func,
    currency: PropTypes.object,
    history: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = { selectedCurrency: props.currency, tempCurrencySelection: null, showCurrencyModal: false };
    this.currencyChange = this.currencyChange.bind(this);
    this.hideCurrencyModal = this.hideCurrencyModal.bind(this);
    this.confirmCurrencyChange = this.confirmCurrencyChange.bind(this);
  }

  componentDidMount() {
    this.props.getCurrencies();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.currency.code !== nextProps.currency.code) {
      this.setState({ selectedCurrency: nextProps.currency });
    }
  }

  currencyChange(currency) {
    const { location } = this.props.history;
    if (
      (location.pathname === '/market-analysis/differentials-engine' ||
        location.pathname.includes(`/market-analysis/geo-differential`)) &&
      currency.code !== 'USD' &&
      currency.code !== '%'
    ) {
      this.setState({ showCurrencyModal: true, tempCurrencySelection: currency });
    } else {
      this.setState({ selectedCurrency: currency });
      this.props.setCurrency(currency);
    }
  }

  hideCurrencyModal() {
    this.setState({ showCurrencyModal: false });
  }

  confirmCurrencyChange() {
    const { tempCurrencySelection } = this.state;
    const { history, setCurrency } = this.props;
    this.setState({ selectedCurrency: tempCurrencySelection, tempCurrencySelection: null, showCurrencyModal: false });
    setCurrency(tempCurrencySelection);
    history.push('/market-analysis/differentials-engine', { fromCurrencySelect: true });
  }

  render() {
    if (!this.props.currencies) {
      return null;
    }

    if (this.props.currencies && this.props.currencies.length === 2) {
      return <div className="currency__single currency--bordered">{this.props.currencies[1].name}</div>;
    }

    return (
      <div className="select currency--bordered">
        <Select
          options={this.props.currencies}
          isClearable={false}
          value={this.state.selectedCurrency}
          getOptionLabel={option => option.name}
          getOptionValue={option => option.code}
          className="react-select-container"
          classNamePrefix="react-select"
          components={{ DropdownIndicator: CustomDropdownIndicator }}
          onChange={this.currencyChange}
          instanceId="currency-select"
        />
        <Modal isOpen={this.state.showCurrencyModal} onClose={this.hideCurrencyModal} className="pulse-currency-modal">
          <h3>No Differentials Data for Selected Currency</h3>
          <div className="pulse-currency-modal__body">
            <span className="primary-text">
              The differentials engine only provides geo and skill differentials data for the US. Changing to a
              different currency will lose all your current progress.
            </span>
            <br />
            <span className="action-text">Do you want to continue?</span>
          </div>
          <ButtonGroup className="pulse-currency-modal__footer">
            <Button variant="secondary" onClick={this.hideCurrencyModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.confirmCurrencyChange}>
              Yes, Change Currency
            </Button>
          </ButtonGroup>
        </Modal>
      </div>
    );
  }
}

const mapState = state => {
  return { ...state.currency, currency: state.session.currency };
};
export default connect(mapState, { getCurrencies, setCurrency })(CurrencySelect);
